import React from 'react';
import {Checkbox} from '@blueprintjs/core';
import {header} from "constants/table";
import { connect } from 'react-redux';
import {ContainerFileDinhKem} from 'components/upload';
import {validatable} from 'components/utils';
import { Reception, DuLieuHeThong } from 'api';
import {
  DropDownChonLoaiDonThu,
  DropDownChonLoaiDoiTuong,
  DropDownChonLinhVucDonThu,
  DropDownChonLinhVucDonThuChiTiet
} from 'components/tt-forms';
import {TextArea, Input, DatePicker, TextMessage} from 'components/tt-forms/common';
import { msg } from "constants/message";
import {ConfirmDialog} from 'modules/dialog';
import {ShowIf} from 'components/utils';

class ThongTinDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loaiDoiTuongId: '',
      linhVucCap1Id: '',
      linhVucCap2Id: '',
      linhVucChiTietKhac: '',
      loaiDonId: '',
      noiDung: '',
      flagCQDaGiaiQuyet: false,
      coQuanDaGiaiQuyetDonThu: '',
      soVanBan: '',
      ngayBanHanh: '',
      loaiDonText: '',
      dsBangChung: [],
      dsBangChungRemove: [],
      dsFileCoQuan: [],
      dsFileCoQuanRemove: [],
      listTaiLieuBangChungTiepNhan: [],
      listTaiLieuBangChung: [],
      listFileCoQuan: [],
      loaiVuViecId: 'MOI_PHAT_SINH',
      loaiVuViecText: '',
      displayTbKhac: false,
      received: false,
      layVuViecCu: false,
      loaiDon: '',
      tarGetValue: '',
      tarGetText: '',
      isChangeLoaiDon: true
    }
  }

  componentDidMount() {
    this.getLoaiVuViec();
    if (this.state.listTaiLieuBangChungTiepNhan && this.state.listTaiLieuBangChungTiepNhan.length === 0) {
      let state = this.state
      state.listTaiLieuBangChungTiepNhan[0] = {
        ten: 'Đơn công dân/Biên bản TCD',
        required: true,
        tenFile: '',
        duongDan: '',
        tinhTrang: '',
        taiLieuBangChungId: ''
      };
      this.setState({...state});
    }
    if (this.state.listTaiLieuBangChung.length == 0) {
      this.state.listTaiLieuBangChung[0] = {
        ten: 'Đơn công dân/Biên bản TCD',
        required: false,
        tenFile: '',
        duongDan: '',
        tinhTrang: '',
        taiLieuBangChungId: ''
      };
      if (this.props.xuLyDon) {
        let state = this.state;
        state.listTaiLieuBangChung[0].ten = 'Đơn của công dân';
        state.listTaiLieuBangChung[0].required = true;
        this.setState({...state});
      }
      if (this.props.loaiVuViecList) {
        this.props.loaiVuViecList.map(item => {
          if (item.giaTri == this.state.loaiVuViecId) {
            this.state.loaiVuViecText = item.ten;
          }
        });
      }
      this.setState({...this.state});
      this.props.onInit({thongTinDon: this.state});
    }
  }

  getLoaiVuViec() {
    if (this.props.loaiVuViecList.length == 0) {
      DuLieuHeThong.actions.getLoaiVuViec.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [
            {
              key: 'loaiVuViecList',
              data: res.data || []
            }
          ]
        })
      })
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: 'RESET_FORM'
    });
  }

  onOpen(name, e) {
    let state = this.state;
    if (this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0) {
      this.props.dispatch({
        type: 'CHANGE_STATE_LOAIDON',
        data: true
      });
    } else {
      this.props.dispatch({
        type: 'CHANGE_STATE_LOAIDON',
        data: false
      });
    }
    state.loaiDon = name;
    state.tarGetValue = e.target.value;
    state.tarGetText = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
    this.setState(state);
  }

  onChange(name, e) {
    let state = this.state;
    let checkLD = this.props && this.props.editData || {};
    let checkBoxvalue = e.nativeEvent.target[e.nativeEvent.target.selectedIndex] && e.nativeEvent.target[e.nativeEvent.target.selectedIndex].value || state.noiDung;

    if (name === 'loaiDonId') {
      state.linhVucCap1Id = '';
      state.linhVucCap2Id = '';
      state.loaiDoiTuongId = '';
      state.linhVucChiTietKhac = '';
      state.displayTbKhac = false;
      state.loaiDonText = e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
      if (checkLD.loaiDon === checkBoxvalue) {
        state.noiDung = this.props.editData.noiDung;
      } else {
        state.noiDung = '';
      }
    }
    if (name === 'linhVucCap1Id') {
      if (e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text === 'Khác') {
        state.displayTbKhac = true;
      } else {
        state.linhVucCap2Id = '';
        state.linhVucChiTietKhac = '';
        state.displayTbKhac = false;
      }
    }
    if (name === 'linhVucCap2Id') {
      if (e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text === 'Khác') {
        state.displayTbKhac = true;
      } else {
        state.displayTbKhac = false;
        state.linhVucChiTietKhac = '';
      }
    }

    if (name === 'loaiDonId') {
      this.setState({
        isChangeLoaiDon: false,
      });
    } else {
      this.setState({
        isChangeLoaiDon: true,
      });
    }
    state[name] = e.target.value;
    this.setState({state}, () => {
      this.props.onChange({thongTinDon: state}, this.state.isChangeLoaiDon);
    });
  }

  onCheck(name) {
    this.state[name] = !this.state[name];
    this.setState({...this.state});
    this.props.onChange({thongTinDon: this.state});
  }

  componentWillReceiveProps(nextProps) {
    let state = this.state;
    if ((nextProps.thongTinDon.donCuId && nextProps.thongTinDon.donCuId !== this.props.thongTinDon.donCuId) || (nextProps.thongTinDon.donId && nextProps.thongTinDon.donId !== this.props.thongTinDon.donId) || nextProps.editData !== this.props.editData) {
      let data = Object.keys(nextProps.thongTinDon) && Object.keys(nextProps.thongTinDon).length > 0 ? nextProps.thongTinDon : nextProps.editData;
      if (state.received !== true) {
        if (data && data.listTaiLieuBangChung && data.listTaiLieuBangChung.length > 0) {
          data.listTaiLieuBangChung.map(item => {
            item.tinhTrang = item.tinhTrangTaiLieu || '';
          });
        }
        if (data && data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet && data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet.length > 0) {
          data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet.map(item => {
            item.tinhTrang = item.tinhTrangTaiLieu || '';
          });
        }
        if (data && data.listTaiLieuBangChung && data.listTaiLieuBangChung.length > 0) {
          state.listTaiLieuBangChung = state.dsBangChung = state.listTaiLieuBangChungTiepNhan = [...data.listTaiLieuBangChung];
        }
        if (data && data.listTaiLieuBangChungTiepNhan && data.listTaiLieuBangChungTiepNhan.length > 0) {
          state.listTaiLieuBangChungTiepNhan = state.listTaiLieuBangChung = state.dsBangChung = [...data.listTaiLieuBangChung];
        }
        if (data && data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet && data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet.length > 0) {
          state.listFileCoQuan = [...data.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet];
        }
      }

      state.layVuViecCu = data.layVuViecCu || false;
      state.loaiDoiTuongId = data.loaiDoiTuong || '';
      state.linhVucCap1Id = data.linhVucDonThuDon ? data.linhVucDonThuDon.linhVucDonThuId : '';
      state.linhVucCap2Id = data.linhVucDonThuChiTietDon ? data.linhVucDonThuChiTietDon.linhVucDonThuId : '';
      if (data.linhVucDonThuChiTietDon && data.linhVucDonThuChiTietDon.ten == 'Khác') {
        state.displayTbKhac = true;
      }
      state.linhVucChiTietKhac = data.linhVucChiTietKhac || '';

      state.loaiDonId = data.loaiDon || '';
      if (Object.keys(nextProps.thongTinDon) && Object.keys(nextProps.thongTinDon).length > 0) {
        if (nextProps.thongTinDon.thongTinGiaiQuyetDonInfo && nextProps.thongTinDon.thongTinGiaiQuyetDonInfo.soVanBan) {
          state.loaiVuViecId = 'MOI_PHAT_SINH';
        } else {
          state.loaiVuViecId = 'CU';
        }
        this.props.loaiVuViecList.map(item => {
          if (item.giaTri === state.loaiVuViecId) {
            state.loaiVuViecText = item.ten;
          }
        });
      } else if (data && data.loaiVuViecInfo && data.loaiVuViecInfo.length > 0) {
        state.loaiVuViecId = data.loaiVuViec;
        state.loaiVuViecText = data.loaiVuViecInfo.ten;
      }
      state.noiDung = data.noiDung;
      if (data.coThongTinCoQuanDaGiaiQuyet === true) {
        state.flagCQDaGiaiQuyet = data.coThongTinCoQuanDaGiaiQuyet;
        if (state.flagCQDaGiaiQuyet) {
          state.coQuanDaGiaiQuyetDonThu = data.coQuanDaGiaiQuyetDonThu || null;
          state.soVanBan = data.soVanBanDaGiaiQuyet || null;
          state.ngayBanHanh = data.ngayBanHanhVanBanDaGiaiQuyet ? new Date(data.ngayBanHanhVanBanDaGiaiQuyet) : '';
        }
      } else {
        if (this.props.isDonCu === false && data && data.thongTinGiaiQuyetDonInfo && data.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo) {
          state.flagCQDaGiaiQuyet = data.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo;
          if (state.flagCQDaGiaiQuyet && data.thongTinGiaiQuyetDonInfo !== null) {
            state.coQuanDaGiaiQuyetDonThu = data.thongTinGiaiQuyetDonInfo && data.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo && data.thongTinGiaiQuyetDonInfo.coQuanDaGiaiQuyetInfo.ten || null;
            state.soVanBan = data.thongTinGiaiQuyetDonInfo && data.thongTinGiaiQuyetDonInfo.soVanBan || null;
            state.ngayBanHanh = data.thongTinGiaiQuyetDonInfo && data.thongTinGiaiQuyetDonInfo.ngayBanHanh ? new Date(data.thongTinGiaiQuyetDonInfo.ngayBanHanh) : '';
          }
        } else {
          state.flagCQDaGiaiQuyet = false;
          state.coQuanDaGiaiQuyetDonThu = null;
          state.soVanBan = null;
          state.ngayBanHanh = '';
        }
      }
      this.props.onInit({thongTinDon: state});
    }
    if (this.props.loaiVuViecList != nextProps.loaiVuViecList) {
      nextProps.loaiVuViecList.map(item => {
        if (item.giaTri === state.loaiVuViecId) {
          this.setState({loaiVuViecText: item.ten});
        }
      });
    }
    if (this.props.huongXuLy !== nextProps.huongXuLy && state.listTaiLieuBangChung.length) {
      state.listTaiLieuBangChung[0].required = nextProps.huongXuLy !== 'TU_CHOI' && nextProps.huongXuLy !== 'KHAC' && nextProps.huongXuLy !== 'YEU_CAU_GAP_LANH_DAO' && nextProps.huongXuLy !== 'TRA_DON_VA_HUONG_DAN' && nextProps.huongXuLy !== "GIAI_QUYET_NGAY" && nextProps.huongXuLy !== "CHO_GIAI_QUYET" ;
    }
    const optionKhac = 63;
    if (this.state.linhVucCap1Id === optionKhac) {
      state.displayTbKhac = true;
    }
    if (this.props.xuLyDon) {
      let state = this.state;
      state.listTaiLieuBangChung[0].required = true;
      this.setState({...state});
    }
    this.setState(state);
  }

  handleChangeDate(name, e) {
    let newData = {
      ...this.state
    }
    if (e && e._d) {
      newData[name] = e._d;
    } else {
      newData[name] = e;
    }
    this.setState({...newData});
    this.props.onChange({thongTinDon: newData});
  }

  onFileRemove(id, data) {
    this.state.dsBangChungRemove = [
      ...this.state.dsBangChungRemove,
      id
    ];
    this.state.dsBangChung = data;
    this.setState({...this.state});
    this.props.onChange({thongTinDon: this.state}, true);
  }
  onFileChange(data) {
    this.state.dsBangChung = data;
    this.setState({...this.state});
    this.props.onChange({thongTinDon: this.state}, true);
  }
  onFileRemoveDGQ(id, data) {
    this.state.dsFileCoQuanRemove = [
      ...this.state.dsFileCoQuanRemove,
      id
    ];
    this.state.dsFileCoQuan = data;
    this.setState({...this.state});
    this.props.onChange({thongTinDon: this.state});
  }
  onFileChangeDGQ(data) {
    this.state.dsFileCoQuan = data;
    this.setState({...this.state});
    this.props.onChange({thongTinDon: this.state});
  }
  confirmSaveLoaiDon(next) {
    let state = this.state;
    if (next) {
      if (this.state.loaiDon === 'loaiDonId') {
        state.linhVucCap1Id = '';
        state.linhVucCap2Id = '';
        state.loaiDoiTuongId = '';
        state.linhVucChiTietKhac = '';
        state.displayTbKhac = false;
        state.loaiDonText = state.tarGetText;
        state[state.loaiDon] = state.tarGetValue;
        this.props.dispatch({
          type: 'CHANGE_STATE_LOAIDON',
          data: false
        });
        this.props.dispatch({
          type: 'REMOVE_LOAIDON_EDIT_FORM',
          data: []
        });
        this.props.soTiepCongDan.listTaiLieuVanThu.forEach((item) => {
          Reception.actions.deleteTepDinhKem.request({
            id: item.taiLieuVanThuId
          });
        });
        this.setState({state});
        this.props.onChange({thongTinDon: state});
      }
    } else {
      this.props.dispatch({
        type: 'CHANGE_STATE_LOAIDON',
        data: false
      });
    }
  }

  render() {
    let isRequire = this.state.listTaiLieuBangChung[0] && this.state.listTaiLieuBangChung[0].required;
    let isLoaiDon = this.state.loaiDonId !== 'DON_KHIEU_NAI' && this.state.loaiDonId !== 'DON_TO_CAO' ? false : true;
    return (
    	<div className="box-items">
        <div className="box-forward">
          <div className="container-box">
            <div className="group-box">
              <div className="title">
                <div className="rows pl5 pr5 mt15">
                  <h3>Thông tin đơn/vụ việc</h3>
                </div>
              </div>
              <div className="items-form">
                <div className="rows">
                  <ShowIf condition={this.props.isDonCu === true && this.props.isKiemTraTCD === false}>
                    <DropDownChonLoaiDonThu require={true} bindValidator={this} selectedValue={this.state.loaiDonId} label="Loại đơn thư" onChange={this.onChange.bind(this, 'loaiDonId')} name="dropdownChonLoaiDonThu" isDonCu={true} isTraCuu={false}/>
                  </ShowIf>
                  <ShowIf condition={this.props.isTraCuu === true && this.props.isKiemTraTCD === undefined}>
                    <DropDownChonLoaiDonThu require={true} bindValidator={this} selectedValue={this.state.loaiDonId} label="Loại đơn thư" onChange={this.onChange.bind(this, 'loaiDonId')} name="dropdownChonLoaiDonThu" isTraCuu={true} isDonCu={false}/>
                  </ShowIf>
                  <ShowIf condition={this.props.isTraCuu === true && this.props.isKiemTraTCD === true}>
                    <ShowIf condition={this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length > 0}>
                      <ConfirmDialog title={msg.confirmChangeSaveLoaiDon} open={this.props.popupConfirmSaveLoaiDon} onClose={this.confirmSaveLoaiDon.bind(this, false)} onSuccess={this.confirmSaveLoaiDon.bind(this, true)}/>
                      <DropDownChonLoaiDonThu require={isRequire ? true : false} bindValidator={this} selectedValue={this.state.loaiDonId} label="Loại đơn thư" onChange={this.onChange.bind(this, 'loaiDonId')} name="dropdownChonLoaiDonThu" isTraCuu={true} isDonCu={false}/>
                    </ShowIf>
                    <ShowIf condition={this.props.soTiepCongDan && this.props.soTiepCongDan.listTaiLieuVanThu && this.props.soTiepCongDan.listTaiLieuVanThu.length === 0}>
                      <DropDownChonLoaiDonThu require={isRequire ? true : false} bindValidator={this} selectedValue={this.state.loaiDonId} label="Loại đơn thư" onChange={this.onChange.bind(this, 'loaiDonId')} name="dropdownChonLoaiDonThu" isTraCuu={true} isDonCu={false}/>
                    </ShowIf>
                  </ShowIf>
                  <DropDownChonLoaiDoiTuong require={isRequire ? isLoaiDon : false} loaiDonThuID={this.state.loaiDonId} bindValidator={this} selectedValue={this.state.loaiDoiTuongId} onChange={this.onChange.bind(this, 'loaiDoiTuongId')} name="dropdownChonLoaiDoiTuong" className={this.state.loaiDonId != 'DON_KHIEU_NAI' && this.state.loaiDonId != 'DON_TO_CAO' ? 'hidden' : ''}/>
                  <DropDownChonLinhVucDonThu require={isRequire ? true : false} bindValidator={this} selectedValue={this.state.linhVucCap1Id} loaiDonThuID={this.state.loaiDonId} onChange={this.onChange.bind(this, 'linhVucCap1Id')} name="dropdownChonLinhVucDonThu"/>
                  <DropDownChonLinhVucDonThuChiTiet loaiDonThuID={this.state.loaiDonId} require={isRequire ? true : false} bindValidator={this} selectedValue={this.state.linhVucCap2Id} linhVucDonThuID={this.state.linhVucCap1Id} onChange={this.onChange.bind(this, 'linhVucCap2Id')} name="dropdownChonLinhVucCap2Id"/>
                  {
                  this.state.displayTbKhac &&
                    <Input label="Lĩnh vực khác" type="text" value={this.state.linhVucChiTietKhac} onChange={this.onChange.bind(this, 'linhVucChiTietKhac')}/>
                  }

                  <TextArea bindValidator={this} channel="formTaoDon" label="Tóm tắt nội dung đơn thư" require={isRequire ? true : false} value={this.state.noiDung} onChange={this.onChange.bind(this, 'noiDung')} name="textareaTomTatNoiDung"/>
                  <ShowIf condition={this.props.isDonCu === false}>
                    <TextMessage className="input-group mb10" label="Loại vụ việc:" value={this.state.loaiVuViecText} />
                  </ShowIf>
                </div>
              </div>
              <div className="title">
                <div className="rows pl5 pr5">
                  <h3 className="mb0-18" >Danh sách tài liệu kèm theo</h3>
                </div>
              </div>
              <div className="items-form  inline-bottom container-filedinhkem">
                <div className="rows">
                  <div className="col-12">
                    {
                      this.props.huongXuLy === "TIEP_NHAN_DON" && this.state.dsBangChung && this.state.dsBangChung.length === 0 ?
                      <ContainerFileDinhKem checkValidate={this.props.checkValidate} name="fileDon" ref='containerFileDinhKem' type='TAI_LIEU_BO_SUNG' header={header.addReception.danhSachBangChung} data={this.state.listTaiLieuBangChungTiepNhan} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} bindValidator={this} onSave={this.props.onSave}/>
                      :
                      <ContainerFileDinhKem
                        checkValidate={this.props.checkValidate}
                        name="fileDon"
                        ref='containerFileDinhKem'
                        type='TAI_LIEU_BO_SUNG'
                        header={header.addReception.danhSachBangChung}
                        data={this.state.listTaiLieuBangChung}
                        onFileRemove={this.onFileRemove.bind(this)}
                        onFileChange={this.onFileChange.bind(this)}
                        bindValidator={this}
                        onSave={this.props.onSave}/>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="group-box">
              <ShowIf condition={this.props.isDonCu === false}>
                <div className="items-form">
                  <div className="rows pl5 pr5">
                    <Checkbox className="pt-large" name="flagCQDaGiaiQuyet" checked={this.state.flagCQDaGiaiQuyet} onChange={this.onCheck.bind(this, 'flagCQDaGiaiQuyet')}>
                      <span className="name_checkbox">Thông tin cơ quan đã giải quyết</span>
                    </Checkbox>
                  </div>
                </div>
              </ShowIf>
              <ShowIf condition={this.state.flagCQDaGiaiQuyet}>
                <div className="title">
                  <div className="rows">
                    <div className="col-12">
                      <h3>Thông tin cơ quan đã giải quyết</h3>
                    </div>
                  </div>
                </div>
                <div className="items-form">
                  <div className="rows">
                    <Input label="Cơ quan đã giải quyết" type="text" value={this.state.coQuanDaGiaiQuyetDonThu} onChange={this.onChange.bind(this, 'coQuanDaGiaiQuyetDonThu')}/>
                    <Input label="Số văn bản" type="text" value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} maxLength={255}/>
                    <DatePicker label="Ngày ban hành" endDate={new Date()} value={this.state.ngayBanHanh} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')}/>
                  </div>
                </div>
                <div className="items-form container-filedinhkem">
                  <div className="rows">
                    <div className="col-12">
                      <ContainerFileDinhKem name="fileCoQuanDaGQ" ref='containerFileDinhKem' data={this.state.listFileCoQuan} onFileRemove={this.onFileRemoveDGQ.bind(this)} onFileChange={this.onFileChangeDGQ.bind(this)} bindValidator={this} onSave={this.props.onSave}/>
                    </div>
                  </div>
                </div>
              </ShowIf>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ThongTinDon.defaultProps = {
  editData: {},
  onSave: false,
  huongXuLy: '',
  popupConfirmSaveLoaiDon: false,
  popupConfirmSaveHuongXuLy: false,
  loaiVuViecList: []
}

function bindStateToProps(state) {
  return {
    thongTinDon: state.formDataTiepCongDan.thongTinDonThu,
    editData: state.formDataTiepCongDan.editData,
    loaiVuViecList: state.duLieuHeThong.loaiVuViecList,
    soTiepCongDan: state.formDataTiepCongDan.soTiepCongDan,
    popupConfirmSaveLoaiDon: state.formDataTiepCongDan.popupConfirmSaveLoaiDon,
    popupConfirmSaveHuongXuLy: state.formDataTiepCongDan.popupConfirmSaveHuongXuLy
  };
}

export default connect(bindStateToProps)(validatable(ThongTinDon));



// WEBPACK FOOTER //
// ./src/components/modules/reception/add-reception/ThongTinDon.jsx